<template>
  <div>
    <form>
      <base-card v-if="!targetItem._id" id="stepSizes" >
        <base-question text="Essa categoria possui tamanhos?"/>

        <div class="d-flex">
            <div class="select-size mr_7" v-bind:class="{ selected: targetItem.sizes.length == 1}" @click.prevent="initSizes(1)">
                <div class="p_20 py_25">
                    <p class="mb_10">
                        <i class="fal fa-soup"></i>
                    </p>
                    <p>Tamanho único</p>
                </div>
            </div>
            <div class="select-size ml_7" v-bind:class="{ selected: targetItem.sizes.length > 1}" @click.prevent="initSizes(2)">
                <div class="p_20 py_25">
                    <p class="mb_10">
                        <i class="fal fa-soup mr_5"></i>
                        <i class="fal fa-soup mr_5"></i>
                        <i class="fal fa-soup"></i>
                    </p>
                    <p>Vários tamanhos</p>
                </div>
            </div>
        </div>
      </base-card>

      <!-- Tamanhos -->
      <div
        id="sizesSection"
        class="base-card-to-listen"
        v-if="targetItem.sizes.length > 1"
      >
        <base-card v-if="targetItem.sizes.filter((i) => !i.delete).length > 0">
           <base-question text="Quais são os tamanhos?" class="mb_15"/>

          <div v-if="targetItem.sizes.length > 0">
            <diV v-for="(size) in targetItem.sizes" :key="size._id">
              <div v-if="!size.delete" class="d-flex">
                <base-input label="Nome do tamanho" v-model="size.name" :disabled="deleteMode.size" class="pr_5 mb_5 w-100" v-on:change="applyValue(size._id, 'name', size.name)" />
                <div v-bind:class="{ 'wpx-min-130 pl_5': deleteMode.size, 'wpx-120': deleteMode.size }">
                  <base-button v-if="deleteMode.size && targetItem.sizes.length > 2" :text="StringLanguage.delete" design="four" @click.prevent="deleteItem(size._id)" class="w-100 big mt_10" />
                </div>
              </div>
            </diV>
          </div>

          <div class="d-flex justify-end w-100 mt_25">
            <base-button v-if="targetItem.sizes.length > 1 && !deleteMode.size" :text="StringLanguage.add" design="two" @click.prevent="addSize()" class="w-100 mr_5" />
            <base-button v-if="targetItem.sizes.length > 2 || deleteMode.size" :text="deleteMode.size ? StringLanguage.back : StringLanguage.remove" design="four" @click.prevent="deleteMode.size = !deleteMode.size" class="w-100 ml_5" />
          </div>
        </base-card>
      </div>
      <!-- fim Tamanhos -->

      <!-- Extra -->
        <sized-list
          v-if="targetItem.sizes.length > 0"
          id="extrasSection"
          title="Esta categoria possui extras?"
          elementPlaceholder="Nome do extra"
          addButtonText="Adicionar extra"
          :deleteMode="deleteMode.extra"
          :sizes="targetItem.sizes"
          :elements="targetItem.extra_ingredients.filter(e => !e.delete)"
          @deleteMode="(activated) => deleteMode.extra = activated"
          @removeElement="(e) => deleteItem(e._id, false)"
          @addNewItem="() => { deleteMode.extra = false, addExtraIngredient() }"
        ></sized-list>
      <!-- fim Ingrediente Extra -->

      <!-- Disponibilidade -->
      <base-availability
        name="da categoria"
        :availability="targetItem.availability"
        @updateAvailability="updateAvailability"
      ></base-availability>
      <!-- fim Disponibilidade -->
    </form>
  </div>
</template>
<script>
import Builder from "easyjs/lib/Schema/Components/Builder";
import Vue from "vue";
import { Money } from "v-money";
import BaseCard from "@/components/Card";
import BaseInput from "@/components/Input";
import BaseButton from "@/components/Button";
import BaseTabs from "@/components/Tabs";
import BaseAdd from "@/components/Add";
import BaseMessage from "@/components/Message";
import BaseRadio from "@/components/Radio";
import BaseQuestion from "@/components/Question";

import SizedList from '@/containers/Catalog/SizedList';
import BaseAvailability from "@/containers/Availability";
import StringTemplate from "easyjs/lib/Tools/StringTemplate";

export default {
  props: {
    setDeleteMode: { type: Function }
  },
  data() {
    return {
      StringTemplate,
      targetItem: Builder.factory("Category"),
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false
      },
      deleteMode: {
        size: false,
        extra: false
      }
    };
  },
  components: {
    BaseCard,
    BaseInput,
    BaseButton,
    BaseTabs,
    BaseAdd,
    BaseMessage,
    BaseRadio,
    BaseQuestion,
    SizedList,
    BaseAvailability,
  },
  watch: {
      targetItem: {
          deep: true,
          handler(newV) {
              this.$emit('updateModel', this.targetItem);
          }
      }
  },
  updated() {
    this.setDeleteMode('step', this.deleteMode);
  },
  methods: {
    updateAvailability(newAvailability) {
      Vue.set(this.targetItem, "availability", newAvailability);
    },
    initSizes(numOfSize) {
      if(!this.targetItem) {
        return;
      }

      let sizeArray = [];
      for(var x = 0; x < numOfSize; x++) {
        let size = Builder.factory('Size');
        size.new = true;
        size._id = Builder.generateRandomId("_");
        size.parent = this.targetItem._id;
        if(numOfSize == 1){
            size.name = 'Tamanho único';
        }
        sizeArray.push(size);
      }

      Vue.set(this.targetItem, 'sizes', sizeArray);

      if(numOfSize == 1) {
        Vue.set(this.targetItem, 'default_sizes', true);
      }
      Vue.nextTick(() => {
        this.$emit("onScrollTo", "#stepSizes");
      })
    },
    cleanModel() {
      for (let key of Object.keys(this.deleteMode)) {
        this.deleteMode[key] = false;
      }
    },
    applyValue(_id, key, value) {
      this.targetItem.getItemsByParam("_id", _id).forEach((i) => {
        Vue.set(i, key, value);
      });
    },
    addNewItem(type, target, node) {
      let item = (node || this.targetItem).getItemsByParam("_id", target)[0];
      let newItem = Builder.factory(type);
      newItem.new = true;
      newItem._id = Builder.generateRandomId("_");
      newItem.parent = item._id;
      item.addItems(newItem);
      return newItem;
    },
    addSize() {
      this.addNewItem("Size", this.targetItem._id);
      this.updateItems();
      this.updateExtras();
      if(this.targetItem.new == false) {
        alert("Tamanho adicionado com sucesso, configure os valores em cada produto.");
      }
    },
    addExtraIngredient() {
      if (this.targetItem.mode == 'simple' || this.targetItem.sizes.filter(i => !i.delete).length > 0) {
        this.addNewItem("Extraingredient", this.targetItem._id);
        this.updateExtras();
      } else {
        alert("Você precisa cadastrar algum tamanho antes.");
      }
    },
    setModel(item, parent) {
      this.cleanModel();
      this.targetItem = item || Builder.factory("Category");
      this.targetItem.parent = null;
      if(this.targetItem.sizes.length == 0) {
        let defaultSize = Builder.factory("Size");
        defaultSize._id = Builder.generateRandomId("_");
        defaultSize.name = "Tamanho Único";
        this.targetItem.addItems(defaultSize);
      }
    },
    deleteItem(id = null, showConfirm = true) {
      if (id) {
        const deleteFn = () => {
            this.targetItem.getItemsByParam("_id", id).forEach(i => Vue.set(i, 'delete', true))
            //Remove todos os tamanhos que foram excluídos
            let catalog = Builder.factory('Catalog');
            catalog.addItems(this.targetItem);
            Builder.executeOnSchema(catalog, (item) => {
              if(item.sizes.length > 0) {
                Vue.set(item, 'sizes', item.sizes.filter(s => !s.delete))
              }
            });
        }

        if(showConfirm) {
          confirm(StringLanguage.confirmDelete, res => res && deleteFn());
        } else {
          deleteFn();
        }

      } else {
        this.targetItem.delete = true;
        this.$emit("saveItem", this.targetItem);
      }
    },
    updateItems() {
      this.targetItem.items.forEach(e => {
        let itemSizes = e.sizes.reduce((obj, size) => ({ ...obj, [size._id]: size }), {});
        e.sizes = this.targetItem.sizes.map(s => {
          return itemSizes[s._id] || Builder.mountSchema(Object.clone(s));
        }).filter(s => !s.delete);
      });
    },
    updateExtras() {
      this.targetItem.extra_ingredients.forEach(e => {
        let extraSizes = e.sizes.reduce((obj, size) => ({ ...obj, [size._id]: size }), {});
        e.sizes = this.targetItem.sizes.map(s => {
          return extraSizes[s._id] || Builder.mountSchema(Object.clone(s));
        }).filter(s => !s.delete);
      });
    }
  }
};
</script>
<style scoped>
.text-title {
  text-transform: uppercase;
  color: #868686;
  font-weight: 900;
  font-size: 10px;
  width: 100%;
  text-align: center;
}
.text-title.double:not(.left) {
  text-align: left !important;
  margin-bottom: 5px;
}
.text-title.left {
  text-align: left !important;
  min-width: 120px;
  max-width: 120px;
  padding-left: 10px;
}
.card-header {
  position: relative;
}

.card-header .close-button,
.card-header .open-button {
  cursor: pointer;
  position: absolute;
  top: -4px;
  right: 5px;
}

.card-header span.open-button {
  top: 4px;
}

.select-size {
  background: var(--box-up);
  width: 100%;
  color: var(--label-primary);
  font-size: 1.2em;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  text-align: center;
  border-radius: 5px;
  border: 1px solid transparent;
  cursor: pointer;
}

.select-size i {
  color: var(--icon-inactive);
  font-size: 1.7em;
}

.select-size:last-child i:nth-child(1) {
  font-size: 1em;
}

.select-size:last-child i:nth-child(2) {
  font-size: 1.3em;
}

.select-size:last-child i:nth-child(3) {
  font-size: 1.6em;
}

.select-size.selected,
.select-size.selected i {
  color: var(--default);
}

.eae-title{
    font-size: 1.4em;
    padding: 16px 0 15px 0;
    text-align: center;
    width: 100%;
    background: #eee;
    margin-bottom: 25px;
    color: #999;
}

</style>
